import { LogoNormal } from '@aidexa/open-ds';
import Image from 'next/image';
import { FC } from 'react';
import styles from './PartnerDesktopLogo.module.scss';

type Props = {
  partnerName: string;
  showPartnerHeader: boolean;
  logoUrl?: string;
};

const PartnerDesktopLogo: FC<Props> = ({ partnerName, showPartnerHeader, logoUrl }) => {
  return (
    <>
      {showPartnerHeader && partnerName !== 'BNL' && <p className={styles.logoDescription}>A cura di</p>}
      {showPartnerHeader && partnerName === 'BNL' && logoUrl && (
        <Image
          className={styles.bnlLogo}
          src={'/onboarding/dinamico/bnl-header-logo.svg'}
          alt={partnerName}
          width={280}
          height={78}
        />
      )}
      {partnerName !== 'BNL' && <LogoNormal />}
    </>
  );
};

export default PartnerDesktopLogo;
